module.exports = __webpack_public_path__ + "img/pentagon.ffd46cb8.svg";